module.exports = "<p>The artist on<br><em>4th Floor to Mildness</em> 2016</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room9/audio1/content.md
// module id = 855
// module chunks = 0